import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaEditComponent.vue?vue&type=template&id=1573093d"
import script from "./RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports